import script from "./Motolino-Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Motolino-Products.vue?vue&type=script&setup=true&lang=js"

import "./Motolino-Products.vue?vue&type=style&index=0&id=16f22492&scoped=true&lang=css"
import "./Motolino-Products.vue?vue&type=style&index=1&id=16f22492&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f22492"]])

export default __exports__